import React, { Suspense, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router';
import { superAdminAuth } from '../../services/superAdminService';
import ApplicationHeader7 from './ApplicationHeader7';
import ApplicationSidebar7 from './ApplicationSidebar7';
import ErrorBoundary from '../../components/common/ErrorBoundary';
import '../../styles/app7.css';

const EntitiesView              = React.lazy(() => import('./EntitiesView'));
const EntityAdminsView          = React.lazy(() => import('./EntityAdminsView'));
const UsersView                 = React.lazy(() => import('./UsersView'));
const LitigationProceedingsView = React.lazy(() => import('./LitigationProceedingsView'));
const RbacView                  = React.lazy(() => import('./RbacView'));

const Layout7: React.FC = () => {
  const navigate = useNavigate();
  const user = superAdminAuth.current();

  useEffect(() => {
    localStorage.removeItem('anygrc_role_theme');
    document.documentElement.setAttribute('data-role', 'super-admin');
    return () => {
      document.documentElement.removeAttribute('data-role');
    };
  }, []);

  if (!superAdminAuth.isAuthenticated()) {
    return <Navigate to="/super-admin/login" replace />;
  }

  const logout = () => {
    superAdminAuth.logout();
    navigate('/super-admin/login');
  };

  return (
    <div className="app-layout">
      <ApplicationHeader7
        loginId={user?.login_id}
        name={user?.name}
        onLogoClick={() => navigate('/super-admin/entities')}
        onLogout={logout}
      />
      <ApplicationSidebar7 />
      <main className="app-layout-content">
        <Suspense fallback={<div className="app-layout-loading" />}>
          <ErrorBoundary>
            <Routes>
              <Route index element={<Navigate to="entities" replace />} />
              <Route path="entities"               element={<EntitiesView />} />
              <Route path="admins"                 element={<EntityAdminsView />} />
              <Route path="users"                  element={<UsersView />} />
              <Route path="litigation-proceedings" element={<LitigationProceedingsView />} />
              <Route path="rbac"                   element={<RbacView />} />
              <Route path="*"                      element={<Navigate to="entities" replace />} />
            </Routes>
          </ErrorBoundary>
        </Suspense>
      </main>
    </div>
  );
};

export default Layout7;
